import React, {Component} from 'react';

import swal from 'sweetalert2';
import axios from "axios/index";

import urls from "../../../../utils/urls";
import {tokenHeader} from "../../../../utils/headers";
import translator from "../../../../utils/translations";
import {ajaxHandler} from "../../../../utils/errors";
import {Spinner} from "../../../../components/Loading/Spinner";
import helpers from "../../../../utils/helpers";

export default class UserForm extends Component {

    constructor(props) {
        super(props);

        let activeState = {
            id: null,
            first_name: '',
            last_name: '',
            username: '',
            email: '',
            terminal: '',
            provider: '',
            group: '',
            found: false
        };

        if (this.props.item) {
            let user = this.props.item;
            activeState = {
                user,
                id: user.id,
                first_name: user.first_name,
                last_name: user.last_name,
                username: user.username,
                email: user.email,
                terminal: user.terminal ? user.terminal.id : '',
                provider: user.provider ? user.provider.id : '',
                group: user.groups && user.groups[0] ? user.groups[0].id : '',
            };
        }

        this.state = {
            ...activeState,
            ajaxInProgress: false,
            terminals: false,
            groups: false,
            providers: false,
        };
    }

    componentDidMount(){
        this._fetchOptions();
    }

    _initializeHTML = () => {
        window.initializeSelects('.admin-modal');
        window.bindSelectAction(this.terminalSelect, this._handleSelectChange);
        window.bindSelectAction(this.providerSelect, this._handleSelectChange);
        window.bindSelectAction(this.groupSelect, this._handleSelectChange);
    };

    _fetchOptions = () => {
        const provider = `${urls.API_ROOT}/api/v1/provider/`;
        const terminal = `${urls.API_ROOT}/api/v1/terminal/`;
        const group = `${urls.API_ROOT}/api/v1/groups/`;
        axios.all([
            axios.get(provider, tokenHeader()),
            axios.get(terminal, tokenHeader()),
            axios.get(group, tokenHeader()),
        ])
            .then(axios.spread(function (prov, term, group) {
                return {
                    providers: prov,
                    terminals: term,
                    groups: group
                }
            }))
            .then((data) => {

                let groups = data.groups.data.filter(gr => gr.name !== helpers.groups.SYSADMIN);

                this.setState({
                    providers: data.providers.data,
                    terminals: data.terminals.data,
                    groups
                }, this._initializeHTML);
            })
            .catch((error) => ajaxHandler(error));
    };

    _handleInput = (prop, value) => {
        this.setState({[prop]: value});
    };

    _handleToggle = (prop, value) => {
        this.setState({[prop]: value});
    };

    _handleSelectChange = (ev) => {
        let target = ev.target;
        let prop = target.getAttribute('data-state-var');

        if(prop !== 'group') {
            this.setState({[prop]: target.value});
            return false;
        }

        let newState = {group: target.value};

        if(this._isUserGroup('terminal', target.value)){
            newState['provider'] = '';
        }else if(this._isUserGroup('provider', target.value)){
            newState['terminal'] = '';
        }else{
            newState['provider'] = '';
            newState['terminal'] = '';
        }

        this.setState(newState, () => window.restartSelects('.admin-modal'));
    };

    _submitForm = () => {

        if(
            (this._isUserGroup('terminal', this.state.group) && this.state.terminal === '') ||
            (this._isUserGroup('provider', this.state.group) && this.state.provider === '')
        ){
            return false;
        }

        this.setState({ajaxInProgress: true});

        if(this.state.id){
            const UPDATE_USER = `${urls.API_ROOT}/api/v1/user/id/${this.state.id}/`;
            let data = {
                group: this.state.group,
                provider: this.state.provider,
                terminal: this.state.terminal
            };

            axios.put(`${UPDATE_USER}`, data, tokenHeader())
                .then(this._onSubmitSuccess)
                .catch(this._onSubmitError);
        }else{
            let data = {
                first_name: this.state.first_name,
                last_name: this.state.last_name,
                username: this.state.username,
                email: this.state.email,
                group: this.state.group,
                provider: this.state.provider,
                terminal: this.state.terminal,
                migrate: true
            };

            if(this.state.found){
                const NEW_USER = `${urls.API_ROOT}/api/v1/create_user/`;
                Object.keys(data).forEach(key => {if (data[key] === ''){data[key] = null;}});
                axios.post(`${NEW_USER}`, data, tokenHeader())
                    .then(this._onSubmitSuccess)
                    .catch(this._onSubmitError);
            }else{
                const VALIDATE_USER = `${urls.API_ROOT}/api/v1/validate_user/?username=${this.state.username}&email=${this.state.email}`;
                axios.get(`${VALIDATE_USER}`, tokenHeader())
                    .then(response => {
                        if(Object.keys(response.data).length === 0){
                            const NEW_USER = `${urls.API_ROOT}/api/v1/create_user/`;
                            Object.keys(data).forEach(key => {if (data[key] === ''){data[key] = null;}});
                            axios.post(`${NEW_USER}`, data, tokenHeader())
                                .then(response => {
                                    this._onSubmitSuccess();
                                })
                                // .then(this._onSubmitSuccess)
                                .catch(this._onSubmitError);
                        }else{
                            let user = response.data;
                            this.setState({
                                first_name: user.first_name,
                                last_name: user.last_name,
                                username: user.username,
                                email: user.email,
                                found: true, ajaxInProgress: false
                            });
                        }
                    })
                    .catch(this._onSubmitError);
            }
        }
    };

    _onSubmitSuccess = () => {
        this.setState({ajaxInProgress: false, found: false});

        swal({
            title: `Usuario ${this.state.id ? 'actualizado' : 'creado'}`,
            html: 'La información ingresada ha sigo guardada correctamente',
            type: 'success',
            showConfirmButton: false,
            timer: 2000
        });

        this.props.closeAction();
        this.props.refreshAction();
    };

    _onSubmitError = (error) => {
        this.setState({ajaxInProgress: false});
        try{
            let response = error.response;
            if(response.status === 400){
                let keys = Object.keys(response.data);
                let details = '';
                for(let i in keys){
                    details = `${details} <p><b>${translator.getFieldName(keys[i])}:</b> ${response.data[keys[i]].join(' ')}</p>`;
                }
                let body = `<div class='swal-container'><p>Se han encontrado los siguientes errores: </p>${details}</div>`;
                swal({
                    title: 'No se ha podido guardar la información del usuario',
                    html: body,
                    type: 'error'
                });
            }else{
                ajaxHandler(error);
            }
        }
        catch (e){
            ajaxHandler(error);
        }
    };

    _isUserGroup = (type, id) => {

        if(type === 'provider'){
            let providerGroup = this.state.groups.find(g => g.name === helpers.groups.PROVIDER);
            if(providerGroup) {
                return (providerGroup.id === parseInt(id, 10));
            }
        }

        if(type === 'terminal'){
            let terminalGroups = this.state.groups.filter(g => g.name === helpers.groups.RECEPTION || g.name === helpers.groups.ISLAND_OPERATOR);
            if(terminalGroups) {
                return (terminalGroups.map(g => g.id).indexOf(parseInt(this.state.group, 10)) > -1) ;
            }
        }

        return false;
    };

    render() {
        if(!this.state.terminals && !this.state.providers && !this.state.groups){
            return (
                <div className={"admin-modal"}>
                    <Spinner />
                </div>
            );
        }

        let showProvider = this._isUserGroup('provider', this.state.group);
        let showTerminal = this._isUserGroup('terminal', this.state.group);

        let translatedGroups = helpers.groupsTranslated();

        let user = this.state.user;
        let form = (
                <div>
                    {this.state.found &&
                    <div className={"row"}>
                        <div className="card-panel grey lighten-3 row z-depth-0" style={{width: '100%', fontSize: '1rem'}}>
                            <div className="col s1">
                                <i className="small material-icons">error_outline</i>
                            </div>
                            <div className="col s11">
                                ¡Atención! Este es un ya registrado en las herramientas de la plataforma, si desea continuar se importarán datos del usuario y se le asignará el perfil asignado dentro de la herramienta
                            </div>
                        </div>
                    </div>
                    }
                    {!this.state.found &&
                    <div>
                        <div className={"row"}>
                            <div className={"col s6 input-field"}>
                                <input placeholder={"Ingrese el nombre"} value={this.state.first_name} type={"text"}
                                       onChange={(ev) => this._handleInput('first_name', ev.target.value)}
                                />
                                <label className="active">Nombre</label>
                            </div>
                            <div className={"col s6 input-field"}>
                                <input placeholder={"Ingrese el apellido"} value={this.state.last_name} type={"text"}
                                       onChange={(ev) => this._handleInput('last_name', ev.target.value)}
                                />
                                <label className="active">Apellido</label>
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col s6 input-field"}>
                                <input placeholder={"Ingrese el usuario"} value={this.state.username} type={"text"}
                                       onChange={(ev) => this._handleInput('username', ev.target.value)}
                                />
                                <label className="active">Usuario</label>
                            </div>
                            <div className={"col s6 input-field"}>
                                <input placeholder={"Ingrese el correo"} value={this.state.email} type={"text"}
                                       onChange={(ev) => this._handleInput('email', ev.target.value)}
                                />
                                <label className="active">Correo Electrónico</label>
                            </div>
                        </div>
                    </div>
                    }
                    {this.state.found &&
                    <div>
                        <div className={"row"}>
                            <div className={"col s6 input-field"}>
                                <label className="active">Nombre</label>
                                <p className={"field-p"}>{this.state.first_name}</p>
                            </div>
                            <div className={"col s6 input-field"}>
                                <label className="active">Apellido</label>
                                <p className={"field-p"}>{this.state.last_name}</p>
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col s6 input-field"}>
                                <label className="active">Usuario</label>
                                <p className={"field-p"}>{this.state.username}</p>
                            </div>
                            <div className={"col s6 input-field"}>
                                <label className="active">Correo Electrónico</label>
                                <p className={"field-p"}>{this.state.email}</p>
                            </div>
                        </div>
                        <div className={"row"} />
                    </div>
                    }
                    <div className={"row"}>
                        <div className={"col s6 input-field"}>
                            <label className="active">Grupo</label>
                            <select defaultValue={this.state.group}
                                    data-state-var="group" ref={ref => {this.groupSelect = ref}}>
                                <option value="">Seleccione un grupo</option>
                                {this.state.groups && this.state.groups.map(group => {
                                    return <option key={group.id} id={group.id}
                                                   value={group.id}>{translatedGroups[group.name]}</option>
                                })}
                            </select>
                        </div>
                        <div className={`col s6 input-field ${showProvider ? '' : 'hide'}`}>
                            <label className="active">Proveedor</label>
                            <select defaultValue={this.state.provider}
                                    data-state-var="provider" ref={ref => {this.providerSelect = ref}}>
                                <option value="">Seleccione proveedor</option>
                                {this.state.providers && this.state.providers.map(provider => {
                                    return <option key={provider.id} id={provider.id}
                                                   value={provider.id}>{provider.business_name}</option>
                                })}
                            </select>
                        </div>
                        <div className={`col s6 input-field ${showTerminal ? '' : 'hide'}`}>
                            <label className="active">Terminal</label>
                            <select defaultValue={this.state.terminal}
                                    data-state-var="terminal"  ref={ref => {this.terminalSelect = ref}}>
                                <option value="">Seleccione una terminal</option>
                                {this.state.terminals && this.state.terminals.map(terminal => {
                                    return <option key={terminal.id} id={terminal.id}
                                                   value={terminal.id}>{terminal.name}</option>
                                })}
                            </select>
                        </div>
                    </div>
                </div>
            );

        if(this.state.id){
            form = (
                <div>
                    <div className={"row"}>
                        <div className={"col s6 input-field"}>
                            <label className="active">Nombre</label>
                            <p className={"field-p"}>{user.first_name}</p>
                        </div>
                        <div className={"col s6 input-field"}>
                            <label className="active">Apellido</label>
                            <p className={"field-p"}>{user.last_name}</p>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col s6 input-field"}>
                            <label className="active">Usuario</label>
                            <p className={"field-p"}>{user.username}</p>
                        </div>
                        <div className={"col s6 input-field"}>
                            <label className="active">Correo Electrónico</label>
                            <p className={"field-p"}>{user.email}</p>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col s6 input-field"}>
                            <label className="active">Grupo</label>
                            <select defaultValue={this.state.group}
                                    data-state-var="group" ref={ref => {this.groupSelect = ref}}>
                                <option value="">Seleccione un grupo</option>
                                {this.state.groups && this.state.groups.map(group => {
                                    return <option key={group.id} id={group.id}
                                                   value={group.id}>{translatedGroups[group.name]}</option>
                                })}
                            </select>
                        </div>
                        <div className={`col s6 input-field ${showProvider ? '' : 'hide'}`}>
                            <label className="active">Proveedor</label>
                            <select defaultValue={this.state.provider}
                                    data-state-var="provider" ref={ref => {this.providerSelect = ref}}>
                                <option value="">Seleccione proveedor</option>
                                {this.state.providers && this.state.providers.map(provider => {
                                    return <option key={provider.id} id={provider.id}
                                                   value={provider.id}>{provider.business_name}</option>
                                })}
                            </select>
                        </div>
                        <div className={`col s6 input-field ${showTerminal ? '' : 'hide'}`}>
                            <label className="active">Terminal</label>
                            <select defaultValue={this.state.terminal}
                                    data-state-var="terminal"  ref={ref => {this.terminalSelect = ref}}>
                                <option value="">Seleccione una terminal</option>
                                {this.state.terminals && this.state.terminals.map(terminal => {
                                    return <option key={terminal.id} id={terminal.id}
                                                   value={terminal.id}>{terminal.name}</option>
                                })}
                            </select>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className={"admin-modal"}>
                <div className={"row"}>
                    <h3 className={"center"}>{this.state.id ? 'Edición de usuario' : 'Alta usuario'}</h3>
                </div>
                {form}
                <div className={"row"}>
                    <div className={"col s12 center"}>
                        <button
                            className={`btn btn-shell-empty z-depth-0 ${this.state.ajaxInProgress ? 'disabled' : ''}`}
                            onClick={this.props.closeAction}
                        >Cancelar</button>
                        <button
                            className={`btn btn-shell z-depth-0 ${this.state.ajaxInProgress ? 'disabled' : ''}`}
                            onClick={this._submitForm}
                        >Guardar</button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/Modals/UserForm.js